// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
import Vuex from "vuex";
import App from './App.vue'
import {
	createSSRApp
} from 'vue'
import store from './store'
import Cache from './utils/cache'
import util from './utils/util'
import * as configs from './config/app.js'
import global from './libs/global.js'
import apps from './libs/apps.js' //校验登录是否失效
import * as Order from './libs/order';
import skeleton from './components/skeleton/index.vue'
import 'animate.css';
// #ifdef MP-WEIXIN
import shareMp from './mixins/shareMp.js';
// #endif
// #ifdef H5
import {
	parseQuery
} from "./utils";
import Auth from './libs/wechat';
import {
	SPREAD
} from './config/cache';

import * as VConsole from './components/vconsole.min.js'
// #endif
/* 
 *Vue3 中，调用成功会进入 then 方法，调用失败会进入 catch 方法
 *Vue2 中，调用无论成功还是失败，都会进入 then 方法，返回数据的第一个参数是错误对象，第二个参数是返回数据
 *Vue 3 转 Vue 2:因为项目由vue2升级过来，所有还是让promise遵循vue2的逻辑 
 */
function isPromise(obj) {
	return (
		!!obj &&
		(typeof obj === "object" || typeof obj === "function") &&
		typeof obj.then === "function"
	);
}

uni.addInterceptor({
	returnValue(res) {
		if (!isPromise(res)) {
			return res;
		}
		const returnValue = [undefined, undefined];
		return res
			.then((res) => {
				returnValue[1] = res;
			})
			.catch((err) => {
				returnValue[0] = err;
			})
			.then(() => returnValue);
	},
});

export function createApp() {
	const app = createSSRApp(App);
	app.component('skeleton', skeleton);
	app.config.globalProperties.$global = global;
	app.config.globalProperties.$util = util;
	app.config.globalProperties.$config = configs;
	app.config.globalProperties.$Cache = Cache;
	app.config.globalProperties.$eventHub = createSSRApp();
	app.config.globalProperties.$Order = Order;
	app.config.globalProperties.$LoginAuth = apps;

	// #ifdef H5
	app.config.globalProperties.$wechat = Auth;
	let cookieName = "VCONSOLE",
		query = parseQuery(),
		urlSpread = query["spread"],
		vconsole = query[cookieName.toLowerCase()],
		md5Crmeb = "b14d1e9baeced9bb7525ab19ee35f2d2", //CRMEB MD5 加密开启vconsole模式
		md5UnCrmeb = "3dca2162c4e101b7656793a1af20295c"; //UN_CREMB MD5 加密关闭vconsole模式
	if (urlSpread) {
		urlSpread = parseInt(urlSpread);
		Cache.setItem({
			name: 'spread',
			value: urlSpread,
		})
		// var spread = Cache.get(SPREAD);
		// urlSpread = parseInt(urlSpread);
		// if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
		// 	Cache.set("spread", urlSpread || 0);
		// } else if (spread === 0 || typeof spread !== "number") {
		// 	Cache.set("spread", urlSpread || 0);
		// }
	}
	if (vconsole !== undefined) {
		if (vconsole === md5UnCrmeb && Cache.has(cookieName))
			Cache.clear(cookieName);
	} else vconsole = Cache.get(cookieName);



	if (vconsole !== undefined && vconsole === md5Crmeb) {
		Cache.set(cookieName, md5Crmeb, 3600);
		let vConsole = new VConsole();
	}
	// #endif
	// #ifdef MP-WEIXIN
	app.mixin(shareMp);
	// #endif
	app.use(store)
	return {
		app,
		Vuex
	}
}
